<script setup lang="ts">
defineProps({
  object: {
    type: Object as PropType<Sanity.Default.Schema.StickyImage>,
    required: true,
  },
})

const { urlFor } = useSanityImage()
</script>

<template>
  <div v-if="object" class="mb-12">
    <div class="grid lg:grid-cols-2 gap-6 lg:gap-12 h-full">
      <div class="lg:min-h-[500px] z-20">
        <nuxt-img
          v-if="object.image"
          :src="urlFor(object.image.asset._ref).height(900).url()"
          :alt="object.image.alt"
          class="object-cover object-center w-full sticky top-0"
          quality="85"
          loading="lazy"
        />
      </div>
      <div class="relative px-4 lg:px-0">
        <div class="max-w-lg pr-0 lg:pr-12 xl:pr-0">
          <div v-if="object.eyebrow" class="eyebrow">
            {{ object.eyebrow }}
          </div>
          <h3 v-if="object.title" class="thin-title">
            {{ object.title }}
          </h3>
          <div v-if="object.body" class="text-gray-700">
            <SanityContentWrapper
              :blocks="object.body"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
